import { render, staticRenderFns } from "./SupportWidget.vue?vue&type=template&id=fee51b94&scoped=true"
import script from "./SupportWidget.vue?vue&type=script&lang=js"
export * from "./SupportWidget.vue?vue&type=script&lang=js"
import style0 from "./SupportWidget.vue?vue&type=style&index=0&id=fee51b94&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee51b94",
  null
  
)

export default component.exports